import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data, this.options)
  },
  watch: {
    data () {
      if (Object.keys(this.data).length) {
        this.renderChart(this.data, this.options)
      } else {
        this._chart.destroy()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/LineChart.js